// @flow
import React, { useState } from 'react';

import LineFavoriteClient from '../../models/favorites/LineFavoriteClient';

type Props = {
  tackleLineId: number,
  isFollowing: ?boolean,
  isSignedIn: boolean,
  token: string,
};

function LineFarvoiteButtonRoot(props: Props) {
  return <LineFarvoiteButton {...props} />;
}

function LineFarvoiteButton({
  tackleLineId,
  isFollowing,
  isSignedIn,
  token,
}: Props) {
  const [following, setFollowing] = useState(isFollowing);

  const onClick = () => {
    const lineFavoriteClient = new LineFavoriteClient();
    if (following) {
      lineFavoriteClient
        .removeFavorite(tackleLineId, token)
        .then(() => setFollowing(false))
        .catch(error => console.error(error));
    } else {
      lineFavoriteClient
        .addFavorite(tackleLineId, token)
        .then(() => setFollowing(true))
        .catch(error => console.error(error));
    }
  };

  return (
    <>
      {isSignedIn ? (
        <a
          data-scope-path="tacklebox/commons/favorite_button_component"
          className={`ga4_click2 ${following ? 'active' : ''}`}
          onClick={onClick}
        >
          きになる
        </a>
      ) : (
        <a
          href="/users/sign_in"
          data-scope-path="tacklebox/commons/favorite_button_component"
          className="ga4_click2"
        >
          きになる
        </a>
      )}
    </>
  );
}

export default LineFarvoiteButtonRoot;
